export default {
    'ERROR-GET-CAMPAIGN-INFO-PROSPECT': {
        'CAMPAIGN-ID-OR-RELATION-ID-REQUIRED': {
            actionType: 'toast',
            message: {
                fr: "L'identifiant de la campagne ou de la relation est requis.",
                en: 'Campaign ID or relation ID is required.',
            },
        },
        'PROSPECT-ID-OR-HELPER-ID-REQUIRED': {
            actionType: 'toast',
            message: {
                fr: "Le prospect ou l'ambassadeur est requis.",
                en: 'Prospect or ambassador ID is required.',
            },
        },
        'MISSING-CAMPAIGN-ID': {
            actionType: 'redirect',
            message: {
                fr: "Impossible de trouver la campagne liée.",
                en: 'Unable to find the related campaign.',
            },
            redirectPath: '/',
        },
        'CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "La campagne n'existe pas ou n'est plus disponible.",
                en: 'The campaign does not exist or is no longer available.',
            },
            redirectPath: '/',
        },
    },
};
